import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';

const container = document.getElementById('root');

// Pages are prerendered at build time (scripts/prerender.js), so crawlers
// get full HTML. When the container already has that server-rendered
// content, hydrate it instead of re-rendering from scratch.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    {
      // Hydration mismatches (e.g. viewport-dependent state) recover by
      // falling back to client rendering; don't spam the console for users.
      onRecoverableError: () => {},
    }
  );
} else {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
